module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4",
    attrs: {
      "icon": "docs"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_vm._v("Ajout installation ")])]), _vm._v(" "), _c('action-bar', {
    staticClass: "px-4 pb-6",
    attrs: {
      "back": {
        name: 'liste-installations',
        params: {
          id: this.$route.params.id
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white"
  }, [_c('form', {
    staticClass: "p-4 md:p-6 space-y-6",
    attrs: {
      "id": "installation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cette installation contient-elle du fluide frigorigène ?")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showFluideSection),
      expression: "showFluideSection"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "type": "radio",
      "name": "showF",
      "id": "showF_ok"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.showFluideSection, true)
    },
    on: {
      "change": [function($event) {
        _vm.showFluideSection = true
      }, function($event) {
        return _vm.choiceDone()
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "showF_ok"
    }
  }, [_c('span', [_vm._v("Oui")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showFluideSection),
      expression: "showFluideSection"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "type": "radio",
      "name": "showF",
      "id": "showF_ko"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.showFluideSection, false)
    },
    on: {
      "change": [function($event) {
        _vm.showFluideSection = false
      }, function($event) {
        return _vm.choiceDone()
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "showF_ko"
    }
  }, [_c('span', [_vm._v("Non")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeChoosed),
      expression: "typeChoosed"
    }]
  }, [(_vm.navigatorOnline && _vm.$user && _vm.$user.id === 2600) ? _c('div', [_c('a', {
    staticClass: "flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200",
    on: {
      "click": function($event) {
        return _vm.$refs.photoOCR.click()
      }
    }
  }, [_vm._v("\n                            Remplissage automatique par photo\n                            "), _c('svg', {
    staticClass: "w-5 h-5 ml-2",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
    }
  })])]), _vm._v(" "), _c('input', {
    ref: "photoOCR",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handlePhotoOCR
    }
  })]) : (!_vm.navigatorOnline && _vm.$user && _vm.$user.id === 2600) ? _c('div', [_c('button', {
    staticClass: "flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-gray-400 bg-gray-300 rounded-lg cursor-not-allowed",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                            Remplissage automatique impossible hors ligne\n                            "), _c('svg', {
    staticClass: "w-5 h-5 ml-2",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
    }
  })])])]) : _vm._e(), _vm._v(" "), (this.$route.query.itag) ? _c('label', [_vm._v("Otag install")]) : _vm._e(), _vm._v(" "), (this.$route.query.itag) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.i_tag),
      expression: "installation.i_tag",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input mt-2",
    attrs: {
      "title": "itag",
      "type": "text",
      "name": "i_tag",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.installation.i_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "i_tag", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label mt-2"
  }, [_vm._v("Nom de l'installation "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.nom),
      expression: "installation.nom",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input flex-1",
    attrs: {
      "title": "installName",
      "type": "text",
      "name": "nom",
      "id": "nom",
      "maxlength": "255",
      "value": ""
    },
    domProps: {
      "value": (_vm.installation.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "nom", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.optionBarcode === true) ? _c('a', {
    staticClass: "bg-secondary text-white ml-2 rounded flex items-center justify-center",
    attrs: {
      "href": "fi360://scan?success=fillCodeBarre&type=installation",
      "id": "barcode-scan"
    }
  }, [_c('img', {
    staticClass: "h-9",
    attrs: {
      "src": require("../../img/barcode-scan.png"),
      "alt": "Scanner le code-barres"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Marque "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFluideSection === false),
      expression: "showFluideSection === false"
    }],
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.marque),
      expression: "installation.marque",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "marque",
      "type": "text",
      "name": "nom",
      "id": "marque",
      "maxlength": "255",
      "value": ""
    },
    domProps: {
      "value": (_vm.installation.marque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "marque", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Modèle / N° de série / Repère "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFluideSection === false),
      expression: "showFluideSection === false"
    }],
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.modele),
      expression: "installation.modele",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "model",
      "type": "text",
      "name": "nom",
      "id": "modele",
      "maxlength": "255",
      "value": ""
    },
    domProps: {
      "value": (_vm.installation.modele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "modele", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-secondary my-6 photo",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.photoInstall.click()
      }
    }
  }, [_vm._v("\n                        PHOTO INSTALLATION / PLAQUE SIGNALETIQUE\n                        "), _c('i', {
    staticClass: "icon-photo"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "photoInstall",
    staticClass: "input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handlePhotoInstall
    }
  }), _vm._v(" "), (_vm.installation.photo) ? _c('div', {
    staticClass: "preview-img"
  }, [_c('i', {
    staticClass: "icon icon-delete",
    on: {
      "click": function($event) {
        _vm.installation.photo = null
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.installation.photo,
      "alt": "photo installation",
      "id": "photo-install"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFluideSection),
      expression: "showFluideSection"
    }]
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type de fluide "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.fluide),
      expression: "installation.fluide"
    }],
    ref: "fluide",
    staticClass: "input",
    attrs: {
      "title": "fluid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "fluide", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateComputed]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Sélectionnez un fluide")]), _vm._v(" "), _vm._l((_vm.fluides), function(fluide) {
    return (fluide && fluide.nom !== 'R-999') ? _c('option', {
      key: fluide && fluide.id,
      domProps: {
        "value": fluide
      }
    }, [_vm._v("\n                            " + _vm._s(fluide.nom) + "\n                            " + _vm._s((fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : '') + "\n                        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Charge totale (Kg) "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.installation.charge),
      expression: "installation.charge",
      modifiers: {
        "number": true
      }
    }],
    ref: "charge",
    staticClass: "input",
    attrs: {
      "title": "chargeTotal",
      "type": "number",
      "step": "0.001",
      "min": "0.010",
      "inputmode": "decimal"
    },
    domProps: {
      "value": (_vm.installation.charge)
    },
    on: {
      "change": _vm.updateComputed,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "charge", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Détecteur de fuite fixe "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    ref: "detec",
    staticClass: "sr-only peer",
    attrs: {
      "name": "detecteur_fuite_fixe",
      "id": "fuite_ok",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.detecteur, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "fuite_ok"
    }
  }, [_c('span', [_vm._v("Oui")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    ref: "detec2",
    staticClass: "sr-only peer",
    attrs: {
      "name": "detecteur_fuite_fixe",
      "id": "fuite_ko",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.detecteur, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-rouge peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "fuite_ko"
    }
  }, [_c('span', [_vm._v("Non")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])])]), _vm._v(" "), (_vm.canForceFrequence === true) ? _c('div', {
    staticClass: "mt-6"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fréquence de contrôle forcée")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "name": "force_frequence",
      "id": "force_frequence",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.force_frequence, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "force_frequence"
    }
  }, [_c('span', [_vm._v("Oui")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    staticClass: "sr-only peer",
    attrs: {
      "name": "force_frequence",
      "id": "force_frequence_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.force_frequence, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-rouge peer-checked:text-white peer-checked:shadow flex items-center justify-between",
    attrs: {
      "for": "force_frequence_no"
    }
  }, [_c('span', [_vm._v("Non")]), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.installation.force_frequence === true) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fréquence de contrôle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.frequence_controle),
      expression: "installation.frequence_controle"
    }],
    staticClass: "input mt-2",
    attrs: {
      "name": "frequence_controle",
      "id": "frequence_controle"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "frequence_controle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24 mois")])])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.installation.tonnage),
      expression: "installation.tonnage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.installation.tonnage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "tonnage", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.installation.frequence_controle),
      expression: "installation.frequence_controle",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.installation.frequence_controle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "frequence_controle", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "100%"
    }
  }, [(_vm.installation.fluide && _vm.installation.fluide.type && _vm.installation.fluide.type !== 'HFO') ? _c('p', [_vm._v("\n                            Tonnage équivalent CO"), _c('span', {
    staticClass: "smallexp"
  }, [_vm._v("2")]), _vm._v(" :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "tonnage"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.tonnage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.installation.fluide && _vm.installation.fluide.gwp) ? _c('p', [_vm._v("\n                            GWP :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "gwp"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.fluide.gwp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.installation.fluide && _vm.installation.fluide.type !== 'CFC' && _vm.installation.detecteur !== null) ? _c('p', [_vm._v("\n                            Fréquence de contrôle de l'installation :\n                            "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "frequence"
    }
  }, [_vm._v(_vm._s(_vm.installation.frequence_controle === 0 || _vm.installation.frequence_controle == null ? 'Aucune' : _vm.installation.frequence_controle + ' Mois'))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeChoosed),
      expression: "typeChoosed"
    }]
  }, [_c('input', {
    staticClass: "btn-primary",
    attrs: {
      "type": "submit",
      "id": "submit-install",
      "name": "new",
      "value": "AJOUTER"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51861134","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/NewInstallation.vue
// module id = 1032
// module chunks = 0